<template>
    <div id="home" class="fixed-background">
        <router-link :to="{ name: 'my-work' }" id="enter">ENTER</router-link>
        <div id="fade-overlay"></div>
    </div>
</template>

<script>
    export default {
        name: 'home',
        data() {
            return {}
        },
        methods: {}
    }
</script>
